import { useCallback, useState } from "react";

import type { GridRowId, GridRowSelectionModel } from "@mui/x-data-grid";

const noSelection = (): GridRowSelectionModel => ({
  type: "include",
  ids: new Set(),
});

export interface ListDrawerState<Row> {
  selectedRow: Row | null;
  isOpen: boolean;
  open: (row: Row) => void;
  close: () => void;
  rowSelectionModel: GridRowSelectionModel;
  setRowSelectionModel: (model: GridRowSelectionModel) => void;
}

// The row whose card is open in a list's drawer, kept in step with the grid's
// row selection so the open row stays highlighted.
export const useListDrawer = <
  Row extends { id: GridRowId }
>(): ListDrawerState<Row> => {
  const [selectedRow, setSelectedRow] = useState<Row | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>(noSelection);

  const open = useCallback((row: Row) => {
    setSelectedRow(row);
    setIsOpen(true);
    setRowSelectionModel({ type: "include", ids: new Set([row.id]) });
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setSelectedRow(null);
    setRowSelectionModel(noSelection());
  }, []);

  return {
    selectedRow,
    isOpen,
    open,
    close,
    rowSelectionModel,
    setRowSelectionModel,
  };
};
